__turbopack_context__.v({
  "action": "TCQdwW_action",
  "icon": "TCQdwW_icon",
  "message": "TCQdwW_message",
  "root": "TCQdwW_root",
});
